module.exports = function() {
	return new Worker(__webpack_public_path__ + "b7d133882f299a6843c4.assets.wrkr.js");
};